import React from "react";
import {Images} from "../controller/Images";
import {Link, NavLink} from "react-router-dom";
import {nameCode, Role} from "../controller/Utils";

function closeSideBar() {
  var ww = document.body.clientWidth;
  if (ww < 1100) {
    const left = document.getElementById("left-sidebar");
    left.classList.toggle("small-side-bar-mobile");
  }
}

export class


Sidebar extends React.Component {
  render() {
    const user = this.props.user;
    return (
      <div id="left-sidebar" className="sidebar">
        <div className="sidebar-scroll">
          <div className="col-12 p-l-0 p-r-0">
            <div className="col-12 padding-0">
              <div className="user-mobile-view">
                <div id="navbar-menu">
                  <div className="user-account">
                    <div className="dropdown">
                      <a className="dropdown-toggle user-name" data-toggle="dropdown">
                        <div className="user-account">
                          <span className="user-img">
                            {user.image ?
                              <img src={Images.user_image} className="user-photo" alt="User Profile Picture"/> :
                              <div className="icon_div">
                                <div className="user_icon">{nameCode(user.first_name, user.last_name)}</div>
                              </div>}
                          </span>
                          <p className="dropdown-toggle user-name">
                            <span>{user.first_name} {user.last_name}</span>
                            <span>{user.email}</span>
                          </p>
                        </div>
                      </a>
                      <ul className="dropdown-menu dropdown-menu-right account">
                        <li>
                          <Link to="/dashboard/quotes/">Quote</Link>
                        </li>
                        <li>
                          <Link to="/dashboard/work-order/">Work Order</Link>
                        </li>
                        <li>
                          <Link to="/dashboard/hotsheet/">Hotsheets Management</Link>
                        </li>
                        <li>
                          <a >Tasks</a>
                        </li>
                        <li>
                          <a ><i className="icon-power" />Logout</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="plus-icon">
                    <a className="btn-toggle-effect">
                      <i className="fa fa-plus" />
                    </a>
                  </div>
                  <form className="search-form">
                    <div id="expend_bar" className="search-bar collapse">
                      <input className="form-control" placeholder="Search" type="text" />
                    </div>
                    <button className="btn btn-search collapsed btn-toggle-effect" type="button" data-toggle="collapse" data-target="#expend_bar" aria-expanded="false" aria-controls="expend_bar">
                      <i className="icon-magnifier" />
                    </button>
                  </form>
                </div>
              </div>
              <nav className="sidebar-nav">
                <ul className="main-menu metismenu panel-group" id="accordion">
                  <li className="panel">
                    <a href="#sub0" className="has-arrow collapsed" data-toggle="collapse">
                      <img className="img-fluid" alt="" src={Images.crm_icon} />
                      <span>AB Accounts</span>
                    </a>
                    <ul id="sub0" className="collapse panel-collapse" data-parent="#accordion">
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/generator/">Generators</NavLink>
                      </li>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/bill-to/">Bills To</NavLink>
                      </li>
                    </ul>
                  </li>
                 <Role allow={["admin", "dispatcher" , "sales", 'staff', "business_development", 'data_management']} user={user}>
                   <li className="panel">
                    <a href="#sub1" className="has-arrow" data-toggle="collapse">
                      <img className="img-fluid" alt="" src={Images.tracks_icon} />
                      <span>AB tracks </span>
                    </a>
                    <ul id="sub1" className="collapse show panel-collapse" data-parent="#accordion">
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/quotes/">Quotes</NavLink>
                      </li>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/work-order/">Work Orders</NavLink>
                      </li>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/hotsheet/">Hotsheets Management</NavLink>
                      </li>
                       <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/work-performed/">Works Performed</NavLink>
                      </li>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/report/">Reports</NavLink>
                      </li>
                      <Role  allow={['data_management', 'admin']} user={user}>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/data-management/">Data Management</NavLink>
                      </li>
                      </Role>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/trash/">Trash</NavLink>
                      </li>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/draft/">Drafts</NavLink>
                      </li>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/waste-profiles/">Waste Profiles</NavLink>
                      </li>
                    </ul>
                  </li>
                 </Role>
                   <Role allow={["admin" , "dispatcher", "sales", 'staff', "business_development", 'data_management']} user={user}>
                  <li className="panel">
                    <a href="#sub2" className="has-arrow collapsed" data-toggle="collapse">
                      <img className="img-fluid" alt="" src={Images.crm_icon} />
                      <span>AB CRM</span>
                    </a>
                    <ul id="sub2" className="collapse panel-collapse" data-parent="#accordion">
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/contacts/">Contacts</NavLink>
                      </li>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/proposals/">Proposals</NavLink>
                      </li>
                      <li>
                        <a onClick={closeSideBar}>Calendar</a>
                      </li>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/project-log">Projects Log</NavLink>
                      </li>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/client-profile">Clients Profile</NavLink>
                      </li>
                      <li>
                        <a onClick={closeSideBar}>Trash</a>
                      </li>
                    </ul>
                  </li>
                   </Role>
                   <Role allow={["admin", 'dispatcher']} user={user}>
                  <li className="panel">
                    <a href="#sub3" className="has-arrow collapsed" data-toggle="collapse">
                      <img className="img-fluid" alt="" src={Images.dispatch_image} />
                      <span>AB Dispatch</span>
                    </a>
                    <ul id="sub3" className="collapse panel-collapse" data-parent="#accordion">
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/queue/">Queues</NavLink>
                      </li>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/routes/">Routes</NavLink>
                      </li>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/live-map/">Live Map</NavLink>
                      </li>
                      <li>
                        <Role allow={['dispatcher']} isReverse={true} user={user}> <a>Routes Report</a></Role>
                      </li>
                    </ul>
                  </li>
                   </Role>
                   <Role allow={["admin", "business_development"]} user={user}>
                  <li className="panel">
                    <a href="#sub4" className="has-arrow collapsed" data-toggle="collapse">
                      <img className="img-fluid" alt="" src={Images.marketing_icon} />
                      <span>AB Marketing</span>
                    </a>
                    <ul id="sub4" className="collapse panel-collapse" data-parent="#accordion">
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/marketing/call-log/">Call Logs</NavLink>
                      </li>
                    </ul>
                  </li>
                   </Role>
                   <Role allow={["admin"]} user={user}>
                  <li className="panel">
                    <a href="#sub5" className="has-arrow collapsed" data-toggle="collapse">
                      <img className="img-fluid" alt="" src={Images.analytics_icon} />
                      <span>AB Analytics</span>
                    </a>
                    <ul id="sub5" className="collapse panel-collapse" data-parent="#accordion">
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/employee-information/">Employees Information</NavLink>
                      </li>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/trucks/">Trucks</NavLink>
                      </li>
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/in-development/">In Development</NavLink>
                      </li>
                    </ul>
                  </li>
                   </Role>
                   <Role allow={["admin"]} user={user}>
                  <li className="panel">
                    <a href="#sub6" className="has-arrow collapsed" data-toggle="collapse">
                      <img className="img-fluid" alt="" src={Images.financial_icon} />
                      <span>AB Financial</span>
                    </a>
                    <ul id="sub6" className="collapse panel-collapse" data-parent="#accordion">
                      <li>
                        <a >Lorem Ipsum</a>
                      </li>
                      <li>
                        <a >Lorem Ipsum</a>
                      </li>
                      <li>
                        <a >Lorem Ipsum</a>
                      </li>
                    </ul>
                  </li>
                 </Role>
                <Role allow={["driver"]} user={user}>
                  <li className="panel">
                    <a href="#sub7" className="has-arrow collapsed" data-toggle="collapse">
                      <img className="img-fluid" alt="" src={Images.tracks_icon}/>
                      <span>My Tracks</span>
                    </a>
                    <ul id="sub7" className="collapse panel-collapse" data-parent="#accordion">
                      <li>
                        <NavLink onClick={closeSideBar} activeClassName="active" to="/dashboard/routes/">My Routes</NavLink>
                      </li>
                      <li>
                        <a>My Schedules</a>
                      </li>
                      <li>
                        <a>My Info</a>
                      </li>
                      <li>
                        <a>My Map</a>
                      </li>
                    </ul>
                  </li>
                </Role>
                </ul>
              </nav>
            </div>
          </div>
          <div className="support-btn-div">
            <a href="#" className="support-btn" >
              <img className="img-fluid" alt="" src={Images.support_icon} />
              <span>Support</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Sidebar.jsx